export const fieldName = 'linkedDocumentIds';
